import { z } from "zod";
const attributesHeadingSchema = z.object({
  slug: z.string().optional(),
  level: z.coerce.number().int().min(1).max(6),
  uid: z.string().optional(),
  isEditable: z.boolean().optional()
}).refine((data) => data.slug !== void 0 || data.uid !== void 0, {
  message: "Either slug or uid must be provided",
  path: ["slug", "uid"]
});
const attributesPageTitleSchema = z.object({
  title: z.string(),
  description: z.string().optional()
});
export {
  attributesHeadingSchema,
  attributesPageTitleSchema
};
//# sourceMappingURL=attributes.js.map
